import React from 'react'
import Heading from '../components/Heading'
import * as Sentry from '@sentry/browser'
import globals from '../globals'

class NotFound extends React.Component {
    createError () {
        globals.handleError('404 Page not found with comments').then(eventId => {
            Sentry.showReportDialog({ eventId: eventId })
        })
    }

    render () {
        return (
            <div className='page-container mb-5'>
                <div className='error-module module'>
                    <Heading title='Oops!' />
                    <div className='module-inner p-4'>
                        <div className='row'>
                            <div className='col-12 col-lg-8'>
                                <h1 className='my-2'>Nothing to see here...</h1>
                                <p>Because this page doesn't exist. If the page should exist please <a href='#' onClick={this.createError.bind(this)}>report feedback</a> and we will make sure we find it for you.</p>
                                <p><a href='#' onClick={this.createError.bind(this)}>Report feedback</a> / <a href='/'>Return home</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NotFound



// WEBPACK FOOTER //
// ./resources/js/pages/NotFound.js